import * as Yup from "yup";

export type exportValueTypes = {
  exportFormat: string;
};

export const initalValues: exportValueTypes = {
  exportFormat: "EXCEL",
};

export const exportValidationSchema = Yup.object({
  exportFormat: Yup.string().required("Facility is Required"),
});
